import WTLogo from '../assets/wt-logo.png';

export default () => ({
  logo: WTLogo,
  business: {
    name: 'Gledesgaver',
  },
});
